// Hook pobrania kosztu zakupu netto produktu z cennika kosztu zakupu –
// GET /sales-crm/clients/:cid/products/:productId/purchase-cost

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmProductPurchaseCostResponse {
  /** Koszt zakupu netto z cennika; null = brak ceny w cenniku. */
  purchaseCostNet: number | null;
}

export const getSalesCrmProductPurchaseCostQueryKey = (
  clientId: number,
  productId: number
) => ['salesCrm', 'product', productId, 'purchaseCost', clientId] as const;

const getSalesCrmProductPurchaseCost = (
  clientId: number,
  productId: number
): Promise<ISalesCrmProductPurchaseCostResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/products/${productId}/purchase-cost`);

export const useGetSalesCrmProductPurchaseCost = (
  clientId: number,
  productId: number | null,
  options?: UseQueryOptions<ISalesCrmProductPurchaseCostResponse, IError>
) =>
  useQuery<ISalesCrmProductPurchaseCostResponse, IError>(
    getSalesCrmProductPurchaseCostQueryKey(clientId, productId ?? 0),
    () => getSalesCrmProductPurchaseCost(clientId, productId as number),
    {
      ...options,
      enabled:
        options?.enabled !== false &&
        clientId > 0 &&
        productId !== null &&
        productId > 0
    }
  );
